import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "activity-tooltip" }
const _hoisted_2 = { class: "activity-name" }
const _hoisted_3 = {
  key: 0,
  class: "copied"
}
const _hoisted_4 = { class: "activity-number" }
const _hoisted_5 = {
  key: 0,
  class: "copied"
}

import { DefinitionItem } from '@/services/entities/DefinitionItem';
import { ref } from 'vue';  
import Popper from 'vue3-popper';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityTooltip',
  props: {
    activityDefinition: {}
  },
  setup(__props: any) {

const props = __props;

const copied = ref<string | null>(null);

function copy(text: string | undefined, key: 'name' | 'number') {
  if (!text) return;
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(() => {
      copied.value = key;
      window.setTimeout(() => (copied.value = null), 1500);
    }).catch(() => fallbackCopy(text, key));
  } else {
    fallbackCopy(text, key);
  }
}

function fallbackCopy(text: string, key: 'name' | 'number') {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    copied.value = key;
    window.setTimeout(() => (copied.value = null), 1500);
  } finally {
    document.body.removeChild(ta);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.activityDefinition?.description) + " ", 1),
      _createVNode(_unref(Popper), {
        hover: "",
        arrow: "",
        placement: "right",
        content: "Copy to clipboard",
        class: "cc-tooltip"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "copy-btn",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (copy(__props.activityDefinition?.description, 'name'))),
            "aria-label": "Copy activity name"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "dx-icon-copy" }, null, -1)
          ]))])
        ]),
        _: 1
      }),
      (copied.value === 'name')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Copied"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(__props.activityDefinition?.activityNumber) + " ", 1),
      _createVNode(_unref(Popper), {
        hover: "",
        arrow: "",
        placement: "right",
        content: "Copy to clipboard",
        class: "cc-tooltip"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "copy-btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (copy(__props.activityDefinition?.activityNumber?.toString() ?? '', 'number'))),
            "aria-label": "Copy activity number"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "dx-icon-copy" }, null, -1)
          ]))])
        ]),
        _: 1
      }),
      (copied.value === 'number')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Copied"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})